<template>
  <BlSheetMv
    :active.sync="isActive"
    auto-height
    style="margin: 0 auto"
    class="max-w-[480px] bl-sheet-page"
    :title="title"
    :text-action="textAction"
    @close="onClose"
    @clickAction="onClickAction"
  >
    <template #content>
      <slot></slot>
    </template>
  </BlSheetMv>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlSheetMv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'BlSheetChildPage',
  components: {
    BlSheetMv,
  },
  props: {
    title: {
      type: String,
      default: 'Filter',
    },
    textAction: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    ...mapGetters(['getPreviousPage']),
  },
  mounted() {
    this.open();
  },
  methods: {
    open() {
      setTimeout(() => {
        this.isActive = true;
      }, 100);
    },
    onClose() {
      document.body.style.overflow = 'auto';
      this.$emit('close');
    },
    onClickAction() {
      this.$emit('clickAction');
    },
  },
};
</script>

<style src="@bukalapak/bazaar-mweb-latest/dist/components/BlSheetMv.css"></style>
<style lang="scss">
.bl-sheet-page {
  .bl-sheet__nav-bar {
    height: auto;
  }
}
</style>
